import { type CustomPreviewProps, customPreviewFor } from "../../game/custom";
import {
  lazy,
  Suspense,
  type ComponentType,
  type LazyExoticComponent,
} from "react";
import { StorefrontLoading } from "@softmax/product-ux/catalog";

import { FrontDoor } from "../front-door/front-door-view";
import { StoreMainPage } from "./store-main-page";
import { previewGameJsonLd } from "../content/preview-content";
import type { FrontDoorData, PreviewSearch } from "../front-door/front-door";

const customViews = new Map<
  string,
  LazyExoticComponent<ComponentType<CustomPreviewProps>>
>();

export function PreviewPage({
  data,
  search,
}: {
  data: FrontDoorData;
  search: PreviewSearch;
}) {
  const custom = customPreviewFor(data.address.corpus);
  let CustomPreview = customViews.get(data.address.corpus);

  if (custom && !CustomPreview) {
    CustomPreview = lazy(custom);
    customViews.set(data.address.corpus, CustomPreview);
  }

  return (
    <FrontDoor data={data} search={search}>
      {(page, refreshPublished) =>
        CustomPreview ? (
          <Suspense fallback={<StorefrontLoading />}>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(previewGameJsonLd(page.content)).replace(
                  /</g,
                  "\\u003c",
                ),
              }}
            />
            <CustomPreview
              content={page.content}
              doorHref={page.doorHref}
              isMember={page.isMember}
              search={search}
            />
          </Suspense>
        ) : (
          <StoreMainPage
            {...page}
            search={search}
            layout="template"
            refreshPublished={refreshPublished}
          />
        )
      }
    </FrontDoor>
  );
}
